import { ThunkDispatch } from 'redux-thunk';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';
import { getCurrentStationObs } from './currentStationObsActions';
import { getDailyForecast } from './forecastActions';
import { getHourlyForecast } from './hourlyForecastActions';

export const GET_CURRENT_CONDITIONS_OBS_DATA = new AsyncAction('GET_CURRENT_CONDITIONS_OBS_DATA');
export const GET_CURRENT_CONDITIONS_HOURLY_DATA = new AsyncAction('GET_CURRENT_CONDITIONS_HOURLY_DATA');
export const GET_CURRENT_CONDITIONS_DAILY_DATA = new AsyncAction('GET_CURRENT_CONDITIONS_DAILY_DATA');

export function getCurrentConditionsObsByLatLon(...params: getCurrentConditionsObsByLatLonParameterObject[]|any[]) {
    return (dispatch: ThunkDispatch<any, undefined, any>) => {
        let paramsObject = {
            location: undefined,
            locationType: undefined,
            offset: undefined,
            units: undefined,
            baseUrl: undefined,
            authId: undefined,
            secret: undefined,
            stdParameters: undefined,
            verbose: undefined,
            refresh: undefined,
            lengthUnit: undefined,
            tempUnit: undefined,
            pressureUnit: undefined,
            speedUnit: undefined,
            stationId: undefined,
            providerId: undefined,
            forecastBaseUrl: undefined,
            cacheDuration: undefined
        };

        paramsObject = mapParamsToObject(params, paramsObject);
        const forecastParams = { ...paramsObject };
        forecastParams.baseUrl = paramsObject.forecastBaseUrl;

        const hourlyForecastParams = { ...forecastParams, length: 1 };

        dispatch({
            type: GET_CURRENT_CONDITIONS_OBS_DATA.base,
            payload: getCurrentStationObs(paramsObject)
        });
        dispatch({
            type: GET_CURRENT_CONDITIONS_HOURLY_DATA.base,
            payload: getHourlyForecast(hourlyForecastParams)
        });
        dispatch({
            type: GET_CURRENT_CONDITIONS_DAILY_DATA.base,
            payload: getDailyForecast(forecastParams)
        });
    }
}

export interface getCurrentConditionsObsByLatLonParameterObject {
    location: string;
    locationType: string;
    offset: number;
    units: number;
    baseUrl: string;
    authId: string;
    secret: string;
    stdParameters: object;
    verbose?: boolean;
    refresh?: boolean;
    lengthUnit: number;
    tempUnit: number;
    pressureUnit: number;
    speedUnit: number;
    stationId: number;
    providerId: number;
    forecastBaseUrl: string;
};
